import { FormContainer, FormInput, Treturn, useFetch } from "@4uhub/lib4uhub";
import { Grid, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import {
  getEsignRuleGroupById,
  updateEsignRuleGroup,
} from "../../../../services/esignRuleGroup.service";

const translationPath = "4uESign.page.automations.signatureGroups.";
const schema = z.object({
  id: z.string(),
  name: z.string().min(1, translationPath + "errors.name"),
  rules: z.array(z.object({ id: z.string(), name: z.string() })),
});
type FormData = z.infer<typeof schema>;

const AutomationRuleGroupForm = () => {
  const { t } = useTranslation();
  const { sendRequest: get, loading: getLoading } = useFetch(
    getEsignRuleGroupById,
  );
  const { sendRequest: update, loading: updateLoading } =
    useFetch(updateEsignRuleGroup);

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<FormData>> => {
      const response = await get(id);
      return response as Treturn<FormData>;
    },
    [get],
  );

  return (
    <FormContainer<FormData>
      updateFunction={(value, id) =>
        update({ item: { id, name: value.name }, id })
      }
      getFunction={getHandler}
      loading={getLoading || updateLoading}
      title={t(translationPath + "title")}
      subtitle={t(translationPath + "edit")}
      subtitleWatchField="name"
      schema={schema}
      fields={(_, form) => (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormInput
              name="name"
              label={t(translationPath + "name")}
              size="small"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              {t(translationPath + "linkedRules")}
            </Typography>
            <List dense disablePadding>
              {(form.getValues("rules") ?? []).map((rule) => (
                <ListItem key={rule.id} disableGutters>
                  <ListItemText primary={rule.name} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      )}
    />
  );
};

export default AutomationRuleGroupForm;
